import {Autocomplete, CircularProgress, TextField} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useScopeSearch from "../../hooks/useScopeSearch";

const ScopeSearchAutocomplete = ({
  value = null,
  onChange,
  excludeIds,
  extraParams,
  label = "Scope",
  width = 300,
  size = "small",
  disabled = false
}) => {
  const theme = useTheme();
  const {inputValue, setInputValue, options, loading, loadingMore, hasMore, loadMore} = useScopeSearch({
    excludeIds,
    extraParams
  });

  // Trigger next page when the listbox is scrolled near its bottom edge.
  const handleListboxScroll = (event) => {
    if (!hasMore || loading || loadingMore) return;
    const el = event.currentTarget;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
      loadMore();
    }
  };

  return (
    <Autocomplete
      disablePortal
      options={options}
      loading={loading}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, v, reason) => {
        if (reason === "reset") return;
        setInputValue(v);
      }}
      onChange={(_, option) => onChange?.(option || null)}
      filterOptions={(x) => x}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      noOptionsText={loading ? "Cargando..." : "No se encontraron scopes"}
      disabled={disabled}
      sx={{width}}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: theme.palette.colors?.background ?? theme.palette.background.paper,
            color: theme.palette.text.primary
          }
        },
        listbox: {
          onScroll: handleListboxScroll,
          sx: {maxHeight: 320}
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading || loadingMore ? <CircularProgress color="inherit" size={16} /> : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }
          }}
        />
      )}
    />
  );
};

export default ScopeSearchAutocomplete;
